export default {
    ip: null,
    ipLocationDetails: null,
    form: {},
    copyData: {},
    dynamicInputValuesModified: null,
    configData: {},
    warning: null,
    useOcr: false,
    restrictDuplicateCustomers: false,
    isIndustrial: true,
    isTaxIdRequired: false,
    isTaxIdMandatory: false,
    taxIdNote: null,
    idDocumentExpiryNote: null,
    cardTypeOverride:null,
    ocrStatusFront:null,
    ocrStatusBack:null,
    addressProofDocumentType:null,
    isShowGuide:false,
}
